// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3Bqfo","colMaxWidth":"Table_colMaxWidth__1eI-j"};